/**
 * Snapchat component JS.
 */

( function( $ ) {

	if ( ! document.querySelector('.snapchat__container') ) {
		return
	}

	$( document ).ready( function() {
		var $imageSectors = $( '.snapchat__circle-piece' );
		var $circleContainer = $( '#snapchat__circle-container' );
		var $imageOverlay = $( '#snapchat__overlay-wrapper' );
		var rotateCircle = rotateCircleR( 0, $imageSectors.toArray(), 0 );
		var $indicator = $( '#snapchat__indicator' );
		var $pointer = $( '#snapchat__pointer' );
		var $pointerImage = $( '#snapchat__pointer-image' );
		var animating = true;
		var scrolledTo = false;

		var scrollDetect = debounce( function() {
			if ( ( $( this ).scrollTop() + $( window ).height() ) >= $( '#snapchat__logo' ).position().top ) {
				if ( ! scrolledTo ) {
					// Run animation.
					introAnimation();

					scrolledTo = true;

					$( document ).off( 'scroll' );
				}
			}
		}, 250 );

		// Run the animation only if
		$( document ).on( 'scroll', scrollDetect.bind( this ) );

		$imageOverlay.on( 'click', function() {
			// Break early if mid animation.
			if ( animating ) {
				return;
			}

			var $this = $( this );

			onImageOverlayClick( $this );
		} );

		$( '.snapchat__image-sector-button' ).on( 'click', function() {
			// Break early if mid animation.
			if ( animating ) {
				return;
			}

			var $this = $( $( this ).children().children( '.snapchat__circle-piece' )[0] );
			onImageSectorClick( $this );
		} );

		$circleContainer.on( 'transitionend', function() {
			$indicator.toggleClass( 'hidden' );
		} );

		/**
		 * This will run the pointer animation. While running other events will
		 * not fire.
		 *
		 * This heavy callback style is used only to have better browser compat
		 * without bringing in a library like RxJS to clean up this Async code.
		 */
		function introAnimation() {
			$pointer.removeAttr( 'style' );
			$pointer.removeClass( 'hidden' );
			$pointer.animate( { "opacity": "1" }, "slow", function() {
				animating = true;
				$pointerImage.addClass( 'animate-click' );
				$pointerImage.one( 'animationstart', function() {
					setTimeout( function() {
						onImageOverlayClick( $imageOverlay );

						$pointerImage.one( 'animationend', function() {
							$pointerImage.removeClass( 'animate-click' );

							$imageOverlay.one( 'transitionend', function() {
								$pointerImage.addClass( 'animate-click' );

								$pointerImage.one( 'animationstart', function() {
									setTimeout( function() {
										onImageOverlayClick( $imageOverlay );

										$pointerImage.one( 'animationend', function() {
											$pointerImage.removeClass( 'animate-click' );

											$imageOverlay.one( 'transitionend', function() {
												var $nextSector = $( '#circle-piece-4' );
												var $nextPosition = $nextSector.offset();

												var $pointerPosition = $pointer.offset();

												// Add extra to the diffs to move the pointer down and to the left over the element.
												var $topDiff = ($nextPosition.top - $pointerPosition.top) + 40;
												var $leftDiff = ($nextPosition.left - $pointerPosition.left) + 20;

												$pointer.animate( {
													'left': '+=' + $leftDiff + 'px',
													'top': '+=' + $topDiff + 'px'
												}, function() {

													$pointerImage.addClass( 'animate-click' );
													$pointerImage.one( 'animationstart', function() {
														setTimeout( function() {
															// Simulate pointer click.
															onImageSectorClick( $nextSector );

															$pointerImage.one( 'animationend', function() {
																$pointerImage.removeClass( 'animate-click' );
																// When the piece finishes rotating simulate a click.
																$imageOverlay.one( 'transitionend', function() {
																	$pointerImage.addClass( 'animate-click' );

																	$pointerImage.one( 'animationstart', function() {
																		setTimeout( function() {
																			// Cycle back to the beginning.
																			var $nextSector = $( '#circle-piece-0' );

																			// Simulate pointer click.
																			onImageSectorClick( $nextSector );

																			$pointerImage.one( 'animationend', function() {
																				$pointerImage.removeClass( 'animate-click' );
																				// When the piece finishes rotating simulate a click.
																				$imageOverlay.one( 'transitionend', function() {
																					$pointer.animate( { "opacity": "0" }, "slow", function() {
																						animating = false;
																						$pointer.addClass( 'hidden' );
																					} );
																				} );
																			} );
																		}, 600 );
																	} );
																} );
															} );
														}, 600 );
													} );
												} );
											} );
										} );
									}, 600 );
								} );
							} );
						} );
					}, 600 );
				} );
			} );
		}

		function onImageOverlayClick( $imageOverlay ) {
			var $visibleImage = $imageOverlay.children( '.visible' )[0];
			var $images = $imageOverlay.children( '.snapchat__overlay-image' );

			var currentIndex = parseInt( $visibleImage.dataset['index'] );

			var nextIndex = findNextIndex( currentIndex );

			// Rotate circle.
			rotateCircle( $circleContainer, nextIndex );
			$indicator.toggleClass( 'hidden' );

			// Adjust indices.
			$( $visibleImage ).removeClass( 'visible' );
			$( $images[ nextIndex ] ).addClass( 'visible' );
		}

		function onImageSectorClick( $imageSector ) {
			var $visibleImage = $imageOverlay.children( '.visible' )[0];
			var $images = $imageOverlay.children( '.snapchat__overlay-image' );

			var currentIndex = parseInt( $visibleImage.dataset['index'] );
			var nextIndex = $imageSector.data( 'index' );

			if ( currentIndex === nextIndex ) {
				return;
			}

			// Rotate circle.
			rotateCircle( $circleContainer, nextIndex );
			$indicator.toggleClass( 'hidden' );

			// Adjust indices.
			$( $visibleImage ).removeClass( 'visible' );
			$( $images[ nextIndex ] ).addClass( 'visible' );
		}
	} );

	function findNextIndex( currentIndex ) {
		var upperBound = 5;
		var lowerBound = 0;

		if ( currentIndex === upperBound ) {
			return lowerBound;
		}

		return currentIndex + 1;
	}

	/**
	 * Rotates the circle to the next index and handles all state transitions.
	 *
	 * @param {int}   rotations    - Counter of how many rotations have occured.
	 * @param {array} list         = List of image elements which will be shuffled.
	 * @param {int}   currentIndex = Current index.
	 */
	function rotateCircleR( rotations, list, currentIndex ) {
		return function( element, nextIndex ) {
			// Break early.
			if ( currentIndex === nextIndex ) {
				return;
			}

			if ( nextIndex === 0 ) {
				rotations++;
			}

			if ( currentIndex > nextIndex && nextIndex !== 0 ) {
				rotations++;
			}
			// Set list to the shifted list.
			list = shiftList( list, currentIndex, nextIndex );

			var degrees = ( nextIndex * 60 ) + ( rotations * 360 );

			element.css( 'transform', 'rotate(' + degrees + 'deg)' );
			currentIndex = nextIndex;
		}
	}

	function shiftList( list, currentIndex, nextIndex ) {
		var shift = nextIndex - currentIndex;
		var cycle = 6;

		// If no shift has occured return current list.
		if ( shift === 0 || ( shift % cycle ) === 0 ) {
			return list;
		}

		if ( shift > 0 ) {
			for ( var i = 0; i < shift; i++ ) {
				var item = list.shift();
				list.push( item );
			}
		} else {
			// Reverse shift.
			list = shiftList( list, currentIndex, nextIndex + cycle );
		}

		return list;
	}

	// Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds. If `immediate` is passed, trigger the function on the
	// leading edge, instead of the trailing.
	function debounce(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};
} ( jQuery ) );

/**
 * Mobile sections.
 */
( function( $ ) {
	$( document ).ready( function() {
		var $imageContainer = $( '#snapchat__overlay-wrapper-mobile' );
		var $images = $( '.snapchat__mobile-image' );
		var $button = $( '#snapchat__pointer-mobile' );
		var nextImage = slideImages( 0 );

		$button.on( 'click', function() {
			var $overlay = $( '#snapchat__mobile-overlay' );

			$overlay.remove();
			$button.off( 'click' );
			$button.remove();

			$imageContainer.on( 'click', function() {
				nextImage( $images );
			} );
		} );
	} );

	function slideImages( activeIndex ) {
		return function( $images ) {
			var nextIndex = findNextIndex( activeIndex, $images.toArray() );

			$( $images[ activeIndex ] ).removeClass( 'active' );
			$( $images[ nextIndex ] ).addClass( 'active' );

			activeIndex = nextIndex;
		};
	}

	function findNextIndex( currentIndex, list ) {
		var upperBound = list.length - 1;
		var lowerBound = 0;

		if ( currentIndex === upperBound ) {
			return lowerBound;
		}

		return currentIndex + 1;
	}
} ( jQuery ) );



// WEBPACK FOOTER //
// ./assets/js/components/layout/snapchat.js